import { useState } from "react";
import ReactDOM from "react-dom";
import "./Post.css";
import Markdown from "../../../components/Markdown/Markdown";
import axios from "../../../public Func/axiosAuth";

const REPORT_REASONS = [
  "Spam",
  "Nudity",
  "Scam",
  "Illigal",
  "Sucide or Self-injury",
  "Violance",
  "Hate Speech",
  "Somthing Else",
];

function PostReportModal({ post, onClose, onReportingChange }) {
  const [somthingElse, setsomthingElse] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [showErrorMessage, setshowErrorMessage] = useState(null);

  // Hiding the Popup Window
  function hideReportForm() {
    onClose();
    setTimeout(() => {
      setsomthingElse(false);
      setshowErrorMessage(null);
      setSelectedReason(null);
    }, 300);
  }

  // Choose a Reason
  function SelectReportReason(event) {
    const reason = event.currentTarget.innerHTML;
    setSelectedReason(reason);
    if (reason === "Somthing Else") {
      setsomthingElse(true);
    } else {
      setsomthingElse(false);
    }
  }

  // Submit the Form
  async function submitReportForm(event) {
    var reason = "";
    // Data Reading and Validation
    if (selectedReason === null) {
      setshowErrorMessage("You Have To Choose a Reason");
      return;
    }
    reason = selectedReason;
    if (selectedReason === "Somthing Else") {
      const inputValue =
        event.currentTarget.parentElement.querySelector("input").value;
      if (inputValue === "") {
        setshowErrorMessage("You Have To Write a Reason");
        return;
      }
      reason = inputValue;
    }
    setshowErrorMessage(null);
    onReportingChange(true);
    try {
      hideReportForm();

      const parent = document.getElementById(post.id);
      if (parent) {
        parent.style.height = parent.scrollHeight + "px";
        function hideScroll() {
          parent.style.height = "0px";
          parent.style.padding = "0px";
          parent.style.margin = "0px auto";
        }
        function dissolve() {
          parent.style.display = "none";
        }
        axios
          .delete(process.env.REACT_APP_BACKEND_URL + "/super/post", {
            data: { postID: post.id, reason: reason },
          })
          .then((res) => {
            setTimeout(hideScroll, 100);
            setTimeout(dissolve, 2000);
          })
          .catch((err) => {
            console.log("Error!!\n", err);
            onReportingChange(false);
          });
      }
    } catch (err) {
      console.log("Error!!\n", err);
      onReportingChange(false);
    }
  }

  return ReactDOM.createPortal(
    <div className="ReportPopupWindow">
      <div className="backgroundBlock" onClick={hideReportForm}></div>
      <div className="ReportForm">
        <h1 className="TitleReport">Report Post</h1>
        <h3 className="ForNextPost">Post Content:</h3>
        <Markdown>{post.mainText}</Markdown>
        <div className="ReportTagOptions">
          {REPORT_REASONS.map((reason) => (
            <span
              key={reason}
              className={
                "ReportTag" +
                (selectedReason === reason ? " selected" : "")
              }
              onClick={SelectReportReason}
            >
              {reason}
            </span>
          ))}
        </div>
        <div className={"ReasonInputForm" + (somthingElse ? " show" : "")}>
          <h2>Reason:</h2>
          <p>Write a Simple Message For the Report Reason</p>
          <input type="text" placeholder="Write the Message" />
        </div>
        <button className="submutReportButton" onClick={submitReportForm}>
          Submit Report
        </button>
        <p className={"ErrorMessage" + (showErrorMessage ? " show" : "")}>
          {showErrorMessage}
        </p>
      </div>
    </div>,
    document.body,
  );
}

export default PostReportModal;
